import React, { FunctionComponent } from "react"
import RightArrow from "../assets/rightArrow"
import {
  TemplateIcon1,
  TemplateIcon2,
  TemplateIcon3,
  TemplateIcon4,
  TemplateIcon5,
} from "../assets/templateIcons"
import { templateDetails } from "../constants/templateSection"

import { AmplitudeEvents } from "../types/amplitudeEvents"
import { sendAmplitudeData } from "../utils/amplitude"
import WhatsInsideModal from "./WhatsInsideModal"

interface TemplatesSectionProps {
  handleSignIn: any
  handleCreateSocial: any
  setIsModalVisible: any
}

// Todo: Refactor needed

const TemplatesSection: FunctionComponent<TemplatesSectionProps> = ({
  handleSignIn,
  handleCreateSocial,
  setIsModalVisible,
}) => {
  const [showWI, setShowWI] = React.useState(false)
  const [templateNumber, setTemplateNumber] = React.useState(0)

  const startTemplateHandler = (
    templateCode: string,
    amplitudeEvent: string
  ) => {
    if (window?.innerWidth < 800) {
      // The body scroll should be disable when the modal is open
      const body = document.querySelector("body")
      body.style.overflow = "hidden"
      sendAmplitudeData(AmplitudeEvents.SHARE_MODAL_OPENED)
      setIsModalVisible(true)
    } else {
      let mixerLink = ""
      if (templateCode.length > 0) {
        const signinLink = process.env.THURSDAY_SIGNIN_URL
        mixerLink = `${signinLink}?auto=true&templateCode=${templateCode}`
      } else {
        mixerLink = process.env.THURSDAY_SIGNIN_URL || ""
      }
      sendAmplitudeData(amplitudeEvent)
      window.location.href = mixerLink
    }
  }
  return (
    <div className="templates-section" id="templates-section">
      <WhatsInsideModal
        show={showWI}
        setShow={setShowWI}
        templateDetail={templateDetails[templateNumber]}
        startTemplateHandler={startTemplateHandler}
        templateNumber={templateNumber}
      />
      <div className="h2Text">Social Templates</div>

      <div className="dollars-container">
        <TemplateIcon1 />
        <TemplateIcon2 />
        <TemplateIcon3 />
        <TemplateIcon4 />
        <TemplateIcon5 />
      </div>

      <div className="body-txt container-subtxt">
        A collection of mixers for all occasions.
      </div>
      <div className="templateDetails-section">
        {templateDetails.map((templateItem, index) => {
          return (
            <div
              className="template-item"
              onClick={() => {
                setShowWI(true)
                setTemplateNumber(index)
              }}
            >
              <div className="template-item-header">
                <div>
                  <div
                    style={{
                      height: "47px",
                      width: "40px",
                      margin: "-10px 0 13px -15px",
                    }}
                  >
                    {templateItem?.template?.logo}
                  </div>
                  <div className="body-txt black-txtBtn">
                    <b>{templateItem?.template?.name}</b>
                  </div>
                </div>

                <div className="time-container">
                  <div className="time-duration">
                    {templateItem?.template?.approximateTime}
                  </div>
                  <div className="minutes-text">minutes</div>
                </div>
              </div>
              <div className="template-item-content pText">
                {templateItem?.template?.description}
              </div>

              <div className="template-item-footer">
                <button
                  onClick={() => {
                    setShowWI(true)
                    setTemplateNumber(index)
                  }}
                  className="txtBtn-with-arrow-section pText txt-btn grey-txtBtn"
                  style={{ marginRight: "25px" }}
                >
                  <p>What’s inside</p>
                </button>
                <button
                  className={`txtBtn-with-arrow-section pText txt-btn ${templateItem?.template.btnTextColor}`}
                  onClick={ev => {
                    ev.stopPropagation()
                    startTemplateHandler(
                      templateItem?.template.templateCode,
                      AmplitudeEvents.CREATE_SOCIAL_FROM_TEMPLATES_CARD1
                    )
                  }}
                >
                  <p>{templateItem?.template?.btnText}</p>

                  <RightArrow
                    color={`var(${templateItem?.template.arrowColor})`}
                    size="24"
                  />
                </button>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TemplatesSection
